import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import { loadLocationWithMessage } from '../../../actions/location'

import Button from '@material-ui/core/Button'
import '../../../styles/assets/css/pages/video_player.css'
import Image from '../../../images/fittbd/star.png'
//import AudioMP3 from '../../../audios/sample1.mp3'

class Intro3 extends Component {
  handleSubmit = (e) => {
    this.props.history.push('/introduction/introduction4')
  }
  handleBack = (e) => {
    this.props.history.push('/introduction/introduction2')
  }
  render() {
    return (
      <div className="row wrapper">
        <div className="small-12 columns">
          <div className="admin_screen_questionaire box_border_video1">
            <div className="title_31 margin-bottom1">How is FITT-BD different from other programs?</div>
            <div className="img_center">
              <img src={Image} alt="star" className="img2" />
            </div>
            <div className="content1">
              <p>At FITT-BD, you play an active role in your treatment. Our team is dedicated to working with you to create a personal treatment plan tailored to your individual goals and the level of care you need.</p>
              <p>FITT-BD is not traditional, one-on-one therapy. Instead of meeting with a clinician every week or two weeks, you may learn skills by attending groups, taking online courses, reading books and articles, or doing brief training sessions with a team clinician.</p>
              <p>FITT-BD is also a short-term program. You can expect to be in the program for six months to a year.</p>
            </div>
            <div className="row top_space1">
              <div className="small-4 columns back_button">
                <Button variant="contained" color="primary" disableElevation
                 onClick={this.handleBack} type="button" >
                  Previous
                </Button>
              </div>
              <div className="small-4 columns next_button">
                <Button variant="contained" color="primary" disableElevation
                 onClick={this.handleSubmit} type="submit" >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Intro3)
